import React, { FC, ReactNode } from "react";
import classNames from "classnames";

type Props = {
  text: string;
  children: ReactNode;
  className?: string;
  position?: "top" | "bottom";
};

const positionClasses = {
  top: "-mt-10",
  bottom: "mt-4",
};

export const Tooltip: FC<Props> = ({
  text,
  position = "top",
  children,
  className,
}) => {
  const tooltip = (
    <span
      className={classNames(
        "tooltip rounded-lg shadow-md py-1 px-3 bg-skyblue-50 border border-skyblue-800 border-solid",
        positionClasses[position],
        className
      )}
    >
      {text}
    </span>
  );

  return (
    <span className="has-tooltip">
      {"top" === position && tooltip}
      {children}
      {"bottom" === position && tooltip}
    </span>
  );
};
